import { Controller } from '@hotwired/stimulus';
import { runbookToolbar } from '../lib/runbook_block';
// The button's words, in the language of the guide panel it sits in (runbook_language_controller
// marks each panel with its `lang`).
const LABELS = {
    en: { copy: 'Copy commands', copied: 'Copied!', slot: 'Fill in the «…» values first', failed: 'Copy failed' },
    'pt-BR': { copy: 'Copiar comandos', copied: 'Copiado!', slot: 'Preencha os valores «…» primeiro', failed: 'Falha ao copiar' }
};
// Adds a "Copy commands" button to each Troubleshooting Guide command block.
//
// The guide's HTML is generated server-side and sanitized, which strips buttons and data attributes, so
// the buttons are added here instead. A block's lines arrive tagged by
// TopologyPresenter::Runbooks#runbook_lines; only the `.rb-cmd` lines are copied, joined one per line,
// so comments and location markers never reach the device. A block that still holds a
// «… not in config» slot is refused rather than copied: pasting it would send the device a placeholder.
class default_1 extends Controller {
    constructor() {
        super(...arguments);
        this.timers = [];
    }
    connect() {
        this.element
            .querySelectorAll('pre.runbook-commands')
            .forEach((pre) => this.decorate(pre));
    }
    disconnect() {
        this.timers.forEach((timer) => window.clearTimeout(timer));
        this.timers = [];
    }
    decorate(pre) {
        if (!pre.querySelector('.rb-cmd'))
            return;
        const toolbar = runbookToolbar(pre);
        if (toolbar.querySelector('.runbook-copy'))
            return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'btn btn-sm btn-outline-secondary runbook-copy';
        button.textContent = this.labels(pre).copy;
        button.addEventListener('click', () => this.copy(pre, button));
        toolbar.append(button);
    }
    async copy(pre, button) {
        const labels = this.labels(pre);
        // The whole block: runbook_run_controller splits it where a result lands, so its lines can span several pres.
        const block = pre.closest('.runbook-block') ?? pre;
        if (block.querySelector('.rb-cmd .rb-slot')) {
            this.flash(button, labels.slot, labels);
            return;
        }
        const text = Array.from(block.querySelectorAll('pre.runbook-commands .rb-cmd'))
            .map((line) => line.textContent ?? '')
            .join('\n');
        try {
            await navigator.clipboard.writeText(text);
            this.flash(button, labels.copied, labels);
        }
        catch {
            this.flash(button, labels.failed, labels);
        }
    }
    flash(button, message, labels) {
        button.textContent = message;
        this.timers.push(window.setTimeout(() => {
            button.textContent = labels.copy;
        }, this.resetAfterValue));
    }
    labels(element) {
        return element.closest('[lang]')?.getAttribute('lang') === 'pt-BR' ? LABELS['pt-BR'] : LABELS.en;
    }
}
default_1.values = { resetAfter: { type: Number, default: 2000 } };
export default default_1;
